import { render, staticRenderFns } from "./CardTooSmall.vue?vue&type=template&id=4bdc005e&scoped=true"
var script = {}
import style0 from "./CardTooSmall.vue?vue&type=style&index=0&id=4bdc005e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc005e",
  null
  
)

export default component.exports